<template>
  <Dashboard :title="settings.title">
    <transition name="slide">
      <div
        v-if="saved"
        class="saved"
      >
        <p>Saved</p>
      </div>
    </transition>
    
    <div id="application">
      <div class="row-small">
        <div class="col-12 col-24-md">
          <div class="row-small">
            <div class="col-24">
              <h3>Settings</h3>

              <Background>
                <div 
                  class="loading-center" 
                  v-if="settings.title === ''"
                >
                  <loading/>
                </div>
                
                <form v-else>
                  <Input
                    placeholder="Title"
                    type="text"
                    :value="settings.title"
                    v-model="settings.title"
                  />

                  <!-- <Input
                    placeholder="Icon"
                    type="file"
                  /> -->

                  <Input
                    placeholder="Description"
                    type="text"
                    :value="settings.description"
                    v-model="settings.description"
                  />

                  <!-- <Input
                    placeholder="Language"
                    type="text"
                    :value="settings.language"
                    v-model="settings.language"
                  /> -->

                  <div class="input">
                    <p>Date</p>

                    <datepicker
                      :monday-first="true"
                      format="d MMMM yyyy"
                      value-format="yyyy-MM-dd"
                      v-model="settings.liveDate"
                      :use-utc="true"
                    >
                    </datepicker>


                  </div>

                  <Button
                    title="Save settings"
                    to=""
                    active=true
                    v-on:handleClick="handleSaveButton()"
                  />
                </form>
              </Background>
            </div>

            <div class="col-24 application--notes">
              <h3>Notes</h3>

              <Background>
                <form>              
                  <textarea v-model="notes"></textarea>
                  
                  <Button
                    title="Save notes"
                    to=""
                    active=true
                    v-on:handleClick="handleSaveNotesButton()"
                  />              
                </form>
              </Background>
            </div>
          </div>
        </div>

        <div class="col-12 col-24-md application--users">
          <h3>Users</h3>

          <Button
            class="application--users--add-button"
            title="Add user"
            to=""
            active=true
            showAddIcon=true
            v-on:handleClick="handleModal"
          />

          <Table
            recordsfoundishidden=true
            :data="accounts"
            :isloading="isLoading"
          >
            <template v-slot:titles>
              <th>Name</th>
              <th></th>
            </template>

            <template v-slot:row>
              <tr 
                class="table--content"
                v-for="(item, index) of accounts"
                v-bind:key="index"
              >
                <TdUser
                  :profileimage="item.profileImage"
                  :name="item.displayname"
                  :email="item.username"
                  :isadmin="item.isAdmin"
                />

                <TdButtons>
                  <RoundedButton
                    title=""
                    danger=true
                    v-on:handleClick="handleRemoveButton(item.id)"
                  >
                    <TrashIcon/>
                  </RoundedButton>                  
                </TdButtons>
              </tr>
            </template>
          </Table>
        </div>
      </div>
    </div>

    <Modal
      closeIcon="true"
      v-on:close="handleModal"
      v-if="!modal.isHidden"
    >      
      <template v-slot:title>
        <h3>Add user</h3>
      </template>

      <template v-slot:content>
        <Table
          recordsfoundishidden=true
          :data="accounts"
          :isLoading="modal.isLoading"
        >
          <template v-slot:titles>
            <th>Name</th>
            <th></th>
          </template>

          <template 
            v-slot:row  
          >
            <tr 
              class="table--content"
              v-for="(item, index) of modal.accounts"
              v-bind:key="index"
            >
              <TdUser
                :profileimage="item.profileImage"
                :name="item.displayname"
                :email="item.username"
                :isadmin="item.isAdmin"
              />

              <TdButtons>
                <Button
                  v-if="item.userExists === false"
                  title="Add user"
                  to=""
                  active=true
                  showAddIcon=true
                  v-on:handleClick="handleAddButton(item.id)"
                />

                <Button
                  v-if="item.userExists === true"
                  title="Remove user"
                  to=""
                  v-on:handleClick="handleRemoveButton(item.id)"
                />
              </TdButtons>
            </tr>
          </template>
        </Table>
      </template>      
    </Modal>
  </Dashboard>
</template>

<script>
  import { API } from '../../../services/api.ts'
  import Dashboard from '../../../components/dashboard/dashboard.vue'  
  import Input from '../../../components/form/input.vue'  
  import Button from '../../../components/buttons/button.vue'
  import RoundedButton from '../../../components/buttons/roundedButton.vue'
  import Modal from '../../../components/modal/modal.vue'
  import Background from '../../../components/background/background.vue'
  import Loading from '../../../components/loading/loading.vue'

  import Table from '../../../components/table/table.vue'
  import TdUser from '../../../components/table/td/user.vue'
  import TdButtons from '../../../components/table/td/buttons.vue'
  import TrashIcon from '../../../icons/trash.vue'
  import Datepicker from 'vuejs-datepicker'
  import moment from 'moment';

  export default {
    name: 'Application',
    components: {
      Dashboard,
      Input,
      Button,
      RoundedButton,
      Modal,

      Background,
      Loading,

      Table,
      TdUser,
      TdButtons,
      TrashIcon,
	  Datepicker,
    },
    data () {
      return {
        saved: false,
        isLoading: true,
        settings: {
          title: '',
          icon: '',
          description: '',
          language: '',
          liveDate: ''
        },
        accounts: [],
        modal: {
          isHidden: true,
          isLoading: true,
          accounts: []
        },
        notes: ''
      }
    },
    methods: {
      handleSaveButton: function() {
		  let dateString = moment.utc(this.settings.liveDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
        API.patch(
          `index.cfm?act=applications.item&id=${this.$route.params.id}`,
          {
            title: this.settings.title,
            description: this.settings.description,
            // icon: this.settings.icon,
            liveDate: dateString
          }
        ).then(
          response => {
            this.saved = true;

            setTimeout(function () {
              this.saved = false;
            }.bind(this), 3000)
          }
        )
      },
      handleSaveNotesButton: function() {
        API.patch(
          `index.cfm?act=applications.item&id=${this.$route.params.id}`,
          {
            notes: this.notes
          }
        ).then(
          response => {
            this.saved = true;

            setTimeout(function () {
              this.saved = false;
            }.bind(this), 3000)
          }
        )
      },
      handleModal: function() {
        if (this.modal.isHidden === true) {
          this.modal.isHidden = false;
        } else {
          this.modal.isHidden = true;
        }

        this.checkIfUserExists();
      },
      checkIfUserExists: function() {
        for (const item of this.modal.accounts) {
          if (item.access.find(vendor => vendor['id'] === parseInt(this.$route.params.id))) {
            item.userExists = true;
          } else {
            item.userExists = false;
          }
        }
      },
      handleAddButton: function(id) {
        API.patch(
        `index.cfm?act=accounts.item&id=${id}`,
        {
          addApplications: `${this.$route.params.id}`
        }
        ).then(
          response => {
            console.log(response);
            location.reload();
          }
        )
      },
      handleRemoveButton: function(id) {
        API.patch(
          `index.cfm?act=accounts.item&id=${id}`,
          {
            removeApplications: `${this.$route.params.id}`
          }
        ).then(
          response => {
            console.log(response);
            location.reload();
          }
        )
      },
    },
    mounted() {
      API.get(
        `index.cfm?act=accounts.list`
      ).then(
        response => {
          this.modal.accounts = response.data.data;
          this.modal.isLoading = false;
          console.log(response);
        }
      )

      API.get(
        `index.cfm?act=applications.item&id=${this.$route.params.id}`
      ).then(        
        response => {          
          let data = response.data.data;

          this.settings.title = data.name;
          this.settings.icon = data.icon;
          this.settings.description = data.description;
          this.settings.language = data.language;
          this.settings.liveDate = moment.utc(data.liveDate, 'YYYY-MM-DD').format();
          this.accounts = data.accounts;
          this.notes = data.notes;
          
          this.isLoading = false;
        }
      )
    }
  }
</script>

<style lang="scss">
  @import "../../../styles/components/mediaQueries.scss";

  .saved {
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    left: 0;
    top: 0;
    width: 100%;
    background-color: #64d252;
    z-index: 999;
    padding: 15px;

    p {
      color: white;
      font-weight: bold;
      font-size: 22px;
    }
  }

  .slide-enter-active, .slide-leave-active {
    transition: opacity .2s;
  }
  .slide-enter, .slide-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  #application {
    .loading-center {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .application--notes {
      margin-top: 30px;
    }
    
    .application--users {
      
      @include media-md {
        margin-top: 30px;
      }

      h3 {
        float: left;
      }

      &--add-button {
        float: right;
      }

      .table {
        float: left;
      }
    }
  }  
</style>
